var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDfinity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3872 0C72.6166 0 66.322 3.07561 59.6776 9.13894C56.5303 11.9949 53.7764 15.0705 51.7656 17.531C51.7656 17.531 55.0003 21.1777 58.5411 25.0882C60.4644 22.7155 63.2184 19.5081 66.4094 16.6083C72.3106 11.204 76.1572 10.1056 78.3872 10.1056C86.6922 10.1056 93.4242 16.9158 93.4242 25.3518C93.4242 33.6999 86.6922 40.5101 78.3872 40.598C77.9932 40.598 77.5122 40.5541 76.9442 40.4223C79.3482 41.5207 81.9712 42.3116 84.4192 42.3116C99.6312 42.3116 102.603 32.0302 102.778 31.2833C103.215 29.394 103.478 27.4168 103.478 25.3957C103.434 11.3797 92.2002 0 78.3872 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2748 50.6597C31.0449 50.6597 37.3395 47.5841 43.9839 41.5208C47.1312 38.6648 49.8851 35.5892 51.8959 33.1287C51.8959 33.1287 48.6611 29.482 45.1204 25.5715C43.197 27.9442 40.4431 31.1516 37.2521 34.0514C31.3509 39.4118 27.4604 40.5541 25.2748 40.5541C16.9693 40.5541 10.2375 33.7439 10.2375 25.3079C10.2375 16.9598 16.9693 10.1496 25.2748 10.0617C25.6682 10.0617 26.149 10.1056 26.7173 10.2374C24.3131 9.13901 21.6903 8.34814 19.2424 8.34814C4.0303 8.34814 1.05779 18.6295 0.882994 19.3764C0.445894 21.2657 0.183594 23.2429 0.183594 25.264C0.183594 39.28 11.4178 50.6597 25.2748 50.6597Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8395 16.828C35.1784 15.2462 27.0478 8.78745 19.2669 8.56776C5.40078 8.22679 1.32468 18.0982 0.973247 19.3714C3.62924 8.3019 13.5296 0.0438149 25.2993 0C34.8943 0 44.5905 9.21291 51.7544 17.5275C51.7662 17.5135 51.7775 17.4999 51.7884 17.4868C51.7884 17.4868 55.0231 21.1336 58.5639 25.044C58.5639 25.044 62.5854 29.7014 66.8693 33.7875C68.5304 35.3693 76.6169 41.7402 84.3979 41.9599C98.6489 42.3553 102.583 31.9422 102.801 31.1513C100.179 42.2674 90.2559 50.5715 78.4529 50.6155C68.855 50.6155 59.1556 41.3965 51.9613 33.0797C51.9471 33.0967 51.9334 33.113 51.9204 33.1287C51.9204 33.1287 48.6857 29.4819 45.1449 25.5715C45.1449 25.5715 41.1234 20.9141 36.8395 16.828ZM0.951172 19.4642C0.9551 19.4418 0.962399 19.4107 0.973247 19.3714C0.965832 19.4023 0.958474 19.4333 0.951172 19.4642Z",
    fill: "#29ABE2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 65.227,
    y1: 3.66876,
    x2: 99.9492,
    y2: 39.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6841,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 38.4063,
    y1: 46.9721,
    x2: 3.6839,
    y2: 11.1997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8929,
    stopColor: "#522785"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfinity);
export default __webpack_public_path__ + "static/media/dfinity.c8606e30.svg";
export { ForwardRef as ReactComponent };